import React, {Component} from 'react';
import {Modal, Form, Input, Select, InputNumber, Button, Radio} from 'antd';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const {Option} = Select;
const formItemLayout = {
    labelCol: {
        span: 7,
    },
    wrapperCol: {
        span: 14,
    },
};
class CarbinPackageModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkCurrency: false,
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleOk = () => {
        const {saveData, editingKey} = this.props;
        const {validateFields, getFieldsValue} = this.props.form;
        validateFields((err, values) => {
            if (err) {
                return;
            }
            values.key = editingKey;
            saveData(values);//getFieldsValue() 获取表单中输入的值
            this.handleCancel();
        });
    };

    handleCancel = () => {
        this.props.hideModal();
        this.props.form.resetFields();
    };
    handleChange = e => {
        if (e) {
            this.setState({checkCurrency: true,}, () => {
                    this.props.form.validateFields(['currency'], {force: true});
                },
            );
        } else {
            this.setState({checkCurrency: false,}, () => {
                    this.props.form.resetFields(['currency']);
                },
            );
        }
    };

    render() {
        const {visible} = this.props;
        // getFieldDecorator用于定义表单中的数据
        const {getFieldDecorator} = this.props.form;
        return (
            <Modal visible={ visible } onCancel={ this.handleCancel } onOk={ this.handleOk } footer={[
                <Button key="back" onClick={this.handleCancel}>
                    取消
                </Button>,
                <AuthButton authority="order_edit:cabin_check" key="submit" type="primary" onClick={this.handleOk}>
                    确定
                </AuthButton>,
            ]}>
                <Form {...formItemLayout}>
                    <Form.Item label="唛头">
                        {getFieldDecorator('boxNo', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="品名(中文)">
                        {getFieldDecorator('name', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="品名(英文)">
                        {getFieldDecorator('nameEn', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="国内HSCode">
                        {getFieldDecorator('hscode', {
                            rules: [{required: true, max: 10, message: '该项必填且最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="国外HSCode">
                        {getFieldDecorator('oHscode', {
                            //rules: [{max:10, message: '该项最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="包装">
                        {getFieldDecorator('packageKind', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="件数">
                        {getFieldDecorator('pcsNumber', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber />)}
                    </Form.Item>
                    <Form.Item label="总毛重(Kg)">
                        {getFieldDecorator('grossWeight', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="kg"/>)} kg
                    </Form.Item>
                    <Form.Item label="总体积(CBM)">
                        {getFieldDecorator('volume', {})(<InputNumber precision={2} step={0.01} suffix="CBM"/>)} CBM
                    </Form.Item>
                    <Form.Item label="总价值">
                        {getFieldDecorator('value', {})(<InputNumber precision={2} step={0.01}
                                                                     onChange={this.handleChange}/>)}
                    </Form.Item>
                    <Form.Item label="币制">
                        {getFieldDecorator('currency', {
                            rules: [{required: this.state.checkCurrency, message: '该项必填',},],
                        })(<Select>
                            <Option value="CNY">CNY</Option>
                            <Option value="USD">USD</Option>
                            <Option value="EUR">EUR</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="是否需要装箱方案">
                        {getFieldDecorator('ifPlan', {
                            initialValue: this.state.ifPlan ? this.state.ifPlan : 'N',
                        })(
                            <Radio.Group onChange={(e) => {
                                this.setState({ifPlan: e.target.value})
                            }} value={this.state.ifPlan}>
                                <Radio value={'Y'}>是</Radio>
                                <Radio value={'N'}>否</Radio>
                            </Radio.Group>
                        )}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}
const CarbinPackageForm = Form.create()(CarbinPackageModal)
export default CarbinPackageForm